import { render } from "./manage_workflows.html?vue&type=template&id=036c6be7&external"
import script from "./manage_workflows.js?vue&type=script&lang=js&external"
export * from "./manage_workflows.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__